<template>
  <div class="footer">
    <div class="footer-item"  v-for='(item,index) of items' :class='[ {on:index === idx} ]' @click="tz(item.push)">
      <img :src="index === idx ? item.imgActive : item.imgUrl"/>
      <div>{{item.name}}</div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  export default {
    data() {
      return {
        items: [
          {
            name: "首页",
            imgUrl:'',
            imgActive:'',
            push: "/main/index"
          }
        ]
      }
    },
    methods: {
      tz:function(url){
        location.href = url
      },
    },
    props: ['idx']
  }
</script>

<style>
  .footer{
    display: flex;
    width: 100%;
    height: 48px;
    background:#fff;
    position:fixed;
    bottom:0;
    border-top:solid 1px rgba(102,102,102,0.1);
    left:0;
  }
  .footer .footer-item{
    flex: 1;
    text-align: center;
    font-size: 13px;
    color: #555;
    padding-top:2px;
    font-weight:bold
  }
  .footer .footer-item img{
    display:block;
    width:26px;
    margin:0 auto;
  }
  .footer .on{
    color:#2c2c2c
  }
</style>
